import { Component, inject, Input } from '@angular/core';
import { AppConfig } from '@app/core/app.config';
import { LeafletComponent } from '@app/shared/components/leaflet/leaflet.component';
import { AbstractMapControlComponent } from '@app/shared/components/map/abstract-map-control.component';
import { TranslateService } from '@ngx-translate/core';
import dayjs from 'dayjs';
import DomToImage from 'dom-to-image';
import * as L from 'leaflet';

@Component({
    selector: 'assets-map-export-control',
    templateUrl: './assets-map-export-control.component.html',
    styleUrls: ['./assets-map-export-control.component.scss'],
    standalone: false
})
export class AssetsMapExportControlComponent extends AbstractMapControlComponent {
  private leafletComponent = inject(LeafletComponent, {host: true});
  private translate = inject(TranslateService);
  private appConfig = inject(AppConfig);


  @Input() public currentLayerName: string;
  @Input() public sidebar: L.Control.Sidebar;

  private attributionImageUrl = '/assets/images/map/export_map_attribution.png';
  private attributionImage = new Image();

  constructor() {
    super();
    this.attributionImage.src = this.attributionImageUrl;
  }

  public exportMap(): void {
    if (this.sidebar.getContainer()) {
      this.sidebar.close();
    }

    // Get the leaflet widget and convert it to an image data URL
    DomToImage.toPng(this.leafletComponent.elementRef.nativeElement, {
      filter: (element: HTMLElement) => {
        return !element?.classList?.contains('leaflet-control')
          || element == this.leafletComponent.legendControl.elementRef.nativeElement
          || element == this.leafletComponent.elementRef.nativeElement.getElementsByClassName('leaflet-control-attribution')[0];
      }
    })
      .then((imageWithoutAttributionDataUrl) => {
        // Convert the data URL of the exported image to an image
        const imageWithoutAttributionElement = new Image();
        imageWithoutAttributionElement.src = imageWithoutAttributionDataUrl;

        // Create a canvas element, allow us to draw on the exported image
        const canvasElement = document.createElement('canvas');
        const canvasContext = canvasElement.getContext('2d');

        imageWithoutAttributionElement.addEventListener('load', () => {
          // Set the dimensions of the canvas as the same of the exported image
          canvasElement.height = imageWithoutAttributionElement.height;
          canvasElement.width = imageWithoutAttributionElement.width;

          // Add the exported image to the canvas
          canvasContext.drawImage(imageWithoutAttributionElement, 0, 0);

          // Add the app attribution at the bottom right of the canvas
          canvasContext.drawImage(this.attributionImage, canvasElement.width - 140, canvasElement.height - 19);

          // Convert back the canvas to an image data URL
          const imageWithAttributionDataUrl = canvasElement.toDataURL('image/png');

          // Create a link and execute a download
          const linkElement = document.createElement('a');
          linkElement.download = this.translate.instant('LABEL.EXPORT_MAP_FILENAME') + '_' + this.currentLayerName.toLowerCase() + '_' + dayjs().format(this.appConfig.DATE_FORMAT) + '.png';
          linkElement.href = imageWithAttributionDataUrl;
          linkElement.click();
          // Remove all element
          linkElement.remove();
          imageWithoutAttributionElement.remove();
          canvasElement.remove();
        });
      });
  }

}
